<template>
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.06714 6.37612V0.206116H6.06714V6.37612L8.65714 3.79612L10.0671 5.20612L5.06714 10.2061L0.0671387 5.20612L1.47714 3.79612L4.06714 6.37612Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'IconArrow',
  props: {
    fill: {
      type: String,
      default: '#ffffff'
    }
  }
}
</script>
